import React from 'react';
import { InputField } from './Input.styled';

const Input = ({ ...props }) => <InputField {...props} />;

export default Input;
